<template>
  <div></div>
</template>

<script>
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import { isFeatureOn } from '@/helpers/feature-flag-helper'
import { permissionsMixin } from '@/mixins/permissions'

export default {
  mixins: [permissionsMixin],
  mounted() {
    if (isFeatureOn('trials') && this.hasAnyPermission('TRIAL_READ')) {
      // TRIALS_COORDINATOR or TRIAL_REVIEWER
      if (isFeatureOn('viper-platform-ui-home-page')) {
        window.location.href = `${window.$appConfig.VUE_APP_PLATFORM_UI_URL}/org/${MyActiveOrganization.id}`
      } else {
        this.$router.push({
          name: 'trials',
          params: { orgId: MyActiveOrganization.id }
        })
      }
    } else if (this.hasAnyPermission('MEMBERSHIP_CREATE')) {
      // ACCESS_MANAGER
      this.$router.push({
        name: 'manage-users',
        params: { orgId: MyActiveOrganization.id }
      })
    } else {
      // unknown
      window.location.href = `${window.$appConfig.VUE_APP_PLATFORM_UI_URL}/org/${MyActiveOrganization.id}/patients`
    }
  }
}
</script>
